module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_fishing_f37f4614205709e7770da95e215de7e8.png";